<template>
    <section class="section section--services">
        <Heading text="Pomáháme rozvíjet Vás i Vaší firmu" />
        <ul class="section__services">
            <li class="section__service" v-for="item in items" v-bind:key="item.text">
                <Service :icon="item.icon" :text="item.text" />
            </li>
        </ul>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import Service from './includes/Service.vue';

    export default {
        name: 'Services',
        components: {
            Heading,
            Service
        },
        data() {
            return {
                items: [
                    {
                        icon: 'personal-development',
                        text: 'Osobnostní rozvoj'
                    },
                    {
                        icon: 'leading-strategy',
                        text: 'Strategie řízení firmy'
                    },
                    {
                        icon: 'psychodiagnostic-methods',
                        text: 'Psychodiagnostické metody'
                    },
                    {
                        icon: 'personal-coaching',
                        text: 'Individuální rozvoj'
                    },
                    {
                        icon: 'education',
                        text: 'Vzdělávání v soft skills'
                    },
                    {
                        icon: 'sensible-hiring',
                        text: 'Smysluplný nábor'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    .section {

        &__services {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            max-width: 120rem;
            padding: 0;
            margin: 6rem auto 0 auto;
            list-style-type: none;
        }

        &--services {
            padding-bottom: 4rem;
        }
    }

    @media (max-width: 999px) {

        .section {

            &__services {
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 1fr 1fr 1fr;
            }
        }
    }

</style>
